
import { 
  puttingTests,
  chippingTests,
  wedgingTests,
  bunkerTests,
  ironTests,
  fairwayWoodTests,
  driverTests 
} from "@/data/level2/tests";

/**
 * Check if a test exists in the available Level 2 tests
 */
export const testExists = (testId: string | null): boolean => {
  if (!testId) return false;
  
  const allTests = [
    ...puttingTests,
    ...chippingTests,
    ...wedgingTests,
    ...bunkerTests,
    ...ironTests,
    ...fairwayWoodTests,
    ...driverTests
  ];
  
  return allTests.some(test => test.id === testId);
};

/**
 * Format point display for Level 2 tests
 * @param point The point identifier (e.g., "D", "E", "F")
 * @param selectedTest The currently selected test ID
 * @returns The formatted distance string for display
 */
export const getFormattedPoint = (point: string, selectedTest?: string | null): string => {
  console.log("testUtils getFormattedPoint - point:", point, "selectedTest:", selectedTest);
  
  // Test iron specifique
  if (selectedTest?.includes('iron')) {
    if (selectedTest === 'iron-long') {
      if (point === 'D') return '130m';
    } else if (selectedTest === 'iron-mid') {
      if (point === 'D') return '80m';
    }
  }
  
  // Test fairwayWood specifique
  if (selectedTest?.includes('fairwayWood')) {
    if (selectedTest === 'fairwayWood-3') {
      if (point === 'D') return '180m';
    } else if (selectedTest === 'fairwayWood-5') {
      if (point === 'D') return '160m';
    }
  }
  
  // Test driver specifique
  if (selectedTest?.includes('driver')) {
    if (point === 'D') return '180m';
  }
  
  // Test bunker spécifique
  if (selectedTest?.includes('bunker')) {
    if (selectedTest === 'bunker-court') {
      if (point === 'D') return '5m';
      if (point === 'E') return '8m';
      if (point === 'F') return '12m';
      // Compatibilité avec les points du niveau 3
      if (point === 'BunkerA') return '5m';
      if (point === 'BunkerB') return '8m';
      if (point === 'BunkerC') return '12m';
    } else if (selectedTest === 'bunker-long') {
      if (point === 'D1') return '15m';
      if (point === 'E1') return '20m';
      // Compatibilité avec les points du niveau 3
      if (point === 'BunkerD') return '15m';
    }
  }
  
  // Check if we're in a wedging test
  if (selectedTest?.includes('wedging')) {
    // Wedging tests formatting for Level 2
    if (point === 'D') return '45m';
    if (point === 'E') return '55m';
    if (point === 'F') return '65m';
    if (point === 'D1') return '75m';
    if (point === 'E1') return '85m';
    if (point === 'F1') return '95m';
    if (point === 'D2') return '45m (pente gauche droite)';
    if (point === 'E2') return '55m (pente gauche droite)';
    if (point === 'F2') return '65m (pente gauche droite)';
    
    // Map Level 3 points to Level 2 distances if they appear
    if (point === 'WedgingA') return '45m';
    if (point === 'WedgingB') return '55m';
    if (point === 'WedgingC') return '65m';
  }
  
  // Chipping tests
  if (selectedTest?.includes('chipping')) {
    if (point === 'D') return '15m';
    if (point === 'E') return '20m';
    if (point === 'F') return '25m';
    if (point === 'D1') return '15m (pente droite)';
    if (point === 'E1') return '20m (pente droite)';
    if (point === 'F1') return '25m (pente droite)';
    if (point === 'D2') return '15m (pente gauche)';
    if (point === 'E2') return '20m (pente gauche)';
    if (point === 'F2') return '25m (pente gauche)';
    if (point === 'D3') return '5m (balle roulée)';
    if (point === 'E3') return '10m (balle roulée)';
    if (point === 'F3') return '15m (balle roulée)';
  }
  
  // Putting tests (default case)
  if (point === 'D') return '1,2m';
  if (point === 'E') return '1,5m';
  if (point === 'F') return '3m';
  if (point === 'D1') return '1,2m (pente en montée)';
  if (point === 'E1') return '1,5m (pente en montée)';
  if (point === 'F1') return '3m (pente en montée)';
  if (point === 'D2') return '1,2m (pente en descente)';
  if (point === 'E2') return '1,5m (pente en descente)';
  if (point === 'F2') return '3m (pente en descente)';
  if (point === 'D3') return '1,2m (pente gauche droite)';
  if (point === 'E3') return '1,5m (pente gauche droite)';
  if (point === 'F3') return '3m (pente gauche droite)';
  if (point === 'D4') return '1,2m (pente droite gauche)';
  if (point === 'E4') return '1,5m (pente droite gauche)';
  if (point === 'F4') return '3m (pente droite gauche)';
  
  return point;
};
